import React from "react";

const items = [
  "ENTERPRISE LEADERS",
  "Modernization Experts",
  "AI Governance Specialists",
  "Fortune 500 Banking",
  "Global Healthcare",
  "Cloud Native Pioneers",
  "Trusted Since 2008",
  "Atlanta · HQ",
];

export const Marquee = () => {
  const loop = [...items, ...items, ...items];
  return (
    <section data-testid="marquee" className="border-y border-zinc-200 bg-zinc-50 dark:border-zinc-800 dark:bg-zinc-900 overflow-hidden">
      <div className="py-5 whitespace-nowrap animate-marquee flex items-center gap-12">
        {loop.map((t, i) => (
          <span
            key={i}
            className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-500 dark:text-zinc-400 inline-flex items-center gap-12"
          >
            {t}
            <span className="h-1 w-1 rounded-full bg-zinc-300 dark:bg-zinc-700" />
          </span>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
